'use client'
import { jsxs, jsx } from 'react/jsx-runtime';
import '@dynamic-labs/sdk-api-core';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import { ReactComponent as SvgFramedLinearGradient } from '../../shared/assets/framed-linear-gradient.js';
import '../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import '../../utils/constants/values.js';
import '../../shared/consts/index.js';

const LinearGradientFrame = ({ Icon }) => (jsxs("div", { className: 'linear-gradient-frame', children: [jsx(SvgFramedLinearGradient, { className: 'linear-gradient-frame__linear-gradient' }), jsx("div", { className: 'linear-gradient-frame__icon', children: Icon })] }));

export { LinearGradientFrame };
